{
    "component-card-search-list.empty-state.title.non-final": "<strong>เชื่อมโยงคลังรายการนี้กับองค์ประกอบซอฟต์แวร์</strong>",
    "component-card.add-chat-channel": "เพิ่มช่องแชท",
    "component-card.chat-channels": "ช่องแชท",
    "component-card.expander.show-more-link": "แสดงเพิ่มเติม {formattedCount} รายการ"
}
